import React from 'react';
const bannerText = <>
    🔥 Nuevo precio:{' '}
    <span style={{
    textDecoration: 'line-through',
    opacity: 0.8
  }} data-id="element-131">
      $60.999
    </span>{' '}
    <span style={{
    color: '#FFD700'
  }} data-id="element-132">
      $14.999
    </span>{' '}
    · 🎉 75% OFF · 💳 3 cuotas sin interés con Mercado Pago
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </>;
export function TopBanner() {
  return <>
      <div className="relative z-50 bg-[#2B3654]" style={{
      color: '#fff',
      padding: '20px 0',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '64px'
    }} data-id="element-133">
        {/* Shine sweep overlay */}
        <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 1,
        overflow: 'hidden'
      }} data-id="element-134">
          <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '60%',
          height: '100%',
          background: 'linear-gradient(105deg, transparent 20%, rgba(255,255,255,0.12) 45%, rgba(255,255,255,0.25) 50%, rgba(255,255,255,0.12) 55%, transparent 80%)',
          animation: 'bannerShine 4s ease-in-out infinite',
          transform: 'translateX(-100%) skewX(-15deg)'
        }} data-id="element-135" />
        </div>

        <div style={{
        whiteSpace: 'nowrap',
        display: 'inline-block',
        animation: 'deslizar 20s linear infinite',
        fontStyle: 'italic',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 2
      }} className="text-[28px] font-sans" data-id="element-136">
          🔥🔥 Nuevo precio: · 🎉 50% OFF · 💳 3 cuotas sin interés con Mercado
          Pago 🔥🔥 Nuevo precio: · 🎉 50% OFF · 💳 3 cuotas sin interés con
          Mercado Pago 🔥🔥 Nuevo precio: · 🎉 50% OFF · 💳 3 cuotas sin interés
          con Mercado Pago
        </div>
      </div>
      <style data-id="element-137">
        {`
          @keyframes deslizar {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-33.33%); }
          }
          @keyframes bannerShine {
            0% { transform: translateX(-100%) skewX(-15deg); }
            100% { transform: translateX(300%) skewX(-15deg); }
          }
        `}
      </style>
    </>;
}